// src/Components/UtmFields.js
import React from 'react';
import { Grid, TextField } from '@mui/material';

const UtmFields = ({ utmSource, setUtmSource, utmMedium, setUtmMedium, utmCampaign, setUtmCampaign, disabled = false }) => (
  <Grid container spacing={2} mt={1} mb={1}>
    <Grid size={{ xs: 12, sm: 4 }}>
      <TextField
        label="Traffic Source · UTM Source"
        placeholder="e.g., Partner Newsletter"
        helperText="Where this scan or link is coming from, such as a partner, platform, placement, or audience source. Use owner below for the staff lead."
        value={utmSource}
        onChange={(e) => setUtmSource(e.target.value)}
        fullWidth
        required
        disabled={disabled}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }}>
      <TextField
        label="Asset / Activity Type · UTM Medium"
        placeholder="e.g., Resource Fair"
        helperText="What this is, such as flyer, qr-code, email, presentation, resource-fair, or social-post."
        value={utmMedium}
        onChange={(e) => setUtmMedium(e.target.value)}
        fullWidth
        required
        disabled={disabled}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }}>
      <TextField
        label="Event / Activity Name · UTM Campaign"
        placeholder="e.g., Illinois VFW State Convention"
        helperText="Specific campaign, event, or activity name, such as illinois-vfw-state-convention."
        value={utmCampaign}
        onChange={(e) => setUtmCampaign(e.target.value)}
        fullWidth
        required
        disabled={disabled}
      />
    </Grid>
  </Grid>
);

export default UtmFields;
